import { PaymentFee } from '@melio/platform-api';
import { getDollarsFromCents } from '@melio/platform-utils';

export const convertPaymentFeeCentsToDollars = (paymentFees: PaymentFee[]) =>
  paymentFees.map((paymentFee) => ({
    type: paymentFee.type,
    amount: getDollarsFromCents(paymentFee.amount),
  }));
